/** @jsxRuntime classic */
/** @jsx jsx */
import { useNavigate, useParams } from "react-router-dom";
import React, { useContext } from "react";
import { jsx } from "@emotion/react";
import { footer } from "./footerStyle";
import { Context } from "./Context";
import {
  AiFillFacebook,
  AiFillInstagram,
  AiFillTwitterSquare,
  AiFillLinkedin,
  AiOutlineCopyright,
  AiFillYoutube,
} from "react-icons/ai";

import iconCall from "../../src/assets/images/icon-call_us.png";
import { FaMapMarkerAlt } from "react-icons/fa";

import iconAvailability from "../../src/assets/images/icon-availability.png";
import { VERSION } from "./version";

function Footer() {
  const navigate = useNavigate();

  const {
    dictionary: { dictionary },
  } = useContext(Context);
  return (
    <>
      <footer css={footer}>
        <div className="content">
          <div className="top">
            <div className="logo-details">
              <h2>{dictionary.home_title}</h2>
              <p>ELITE SPORTS SOCCER 18</p>
            </div>

            <div className="media-icons">
              <a href="https://www.facebook.com/EliteSoccer18">
                <AiFillFacebook
                  className="social-media-icons"
                  onMouseOver={({ target }) => (target.style.color = "#79c942")}
                  onMouseOut={({ target }) => (target.style.color = "white")}
                />
              </a>
              <a href="https://www.instagram.com/elitesoccer18">
                <AiFillInstagram
                  className="social-media-icons"
                  onMouseOver={({ target }) => (target.style.color = "#79c942")}
                  onMouseOut={({ target }) => (target.style.color = "white")}
                />
              </a>

              <AiFillTwitterSquare
                onClick={() => navigate("https://twitter.com/Soccer18Elite")}
                className="social-media-icons"
                onMouseOver={({ target }) => (target.style.color = "#79c942")}
                onMouseOut={({ target }) => (target.style.color = "white")}
              />
              <a href="https://www.linkedin.com/company/elite-sports-17-sl/?originalSubdomain=es">
                <AiFillLinkedin
                  className="social-media-icons"
                  onMouseOver={({ target }) => (target.style.color = "#79c942")}
                  onMouseOut={({ target }) => (target.style.color = "white")}
                />
              </a>
              <a href="https://www.youtube.com/channel/UCKHUrEYYNvUq5Aqy9kOGA1g">
                <AiFillYoutube
                  className="social-media-icons"
                  onMouseOver={({ target }) => (target.style.color = "#79c942")}
                  onMouseOut={({ target }) => (target.style.color = "white")}
                />
              </a>
            </div>
          </div>

          <div className="link-boxes">
            <ul className="box one">
              <h3 className="link_name">ELITE SPORTS 18 S.L.</h3>
              <li>
                <li>
                  <FaMapMarkerAlt />
                  C/ Azorin, 5, <span> 46210 Picaña, Valencia</span>
                  <li
                    className="link_office"
                    style={{
                      marginBottom: "-2px",
                      marginRight: "12px",
                      color: "white",
                    }}
                  >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;[{" "}
                    {dictionary.footer_office} ]
                  </li>
                  <li>
                    <br />
                  </li>
                  <FaMapMarkerAlt />
                  C/ Álvaro de Bazán, 17 - 3,
                  <span> 46010, Valencia, España</span>
                </li>
              </li>
              {/* <li>España</li> */}
            </ul>

            <ul className="box two">
              <h3 className="link_name">{dictionary.footer_organizaations}</h3>

              <li>Wizard Football</li>
              <li>
                <a href="https://elitesports17.com">Elite Sports 17</a>
              </li>
            </ul>

            <ul className="box three">
              <h3 className="link_name">{dictionary.footer_legal}</h3>
              <li onClick={() => navigate("/legal-disclaimers")}>
                {dictionary.footer_legal_disclaimers}
              </li>
              <li onClick={() => navigate("/privacy-policy")}>
                {" "}
                {dictionary.footer_privacy}
              </li>
              <li onClick={() => navigate("/cookies-policy")}>
                {dictionary.footer_cookies}
              </li>
            </ul>
          </div>

          <div className="data">
            <div className="data-info telephone">
              <div>
                <img src={iconCall} loading="lazy" alt="call-us" />
              </div>
              <div>
                <p>
                  &nbsp;{dictionary.contact_call_us} &nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    <br />
                    &nbsp;&nbsp;+34 641 88 06 97{" "}
                  </span>
                  <span style={{ fontWeight: "bold" }}>
                    <br />
                    &nbsp;&nbsp;+34 962 43 93 34 &nbsp;(
                    {dictionary.footer_office})
                  </span>
                </p>
              </div>
            </div>

            <div className="data-info opening">
              <div>
                <img src={iconAvailability} loading="lazy" alt="availability" />
              </div>
              <div>
                <p>&nbsp;{dictionary.date_open_min}</p>
              </div>
            </div>
          </div>

          <div className="footer_copy_right">
            <div className="footer-copy_right_data">
              <div className="footer-inner-data">
                <AiOutlineCopyright
                  style={{ position: "relative", top: "2px" }}
                />
                &nbsp; Elite Sports Soccer 18{" . "}
                <span style={{ color: "darkblue" }}>{VERSION}</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
